function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.818 45.84a9.66 9.66 0 11-19.318 0 9.66 9.66 0 1119.318 0zM55.879 45.84a9.66 9.66 0 11-19.318 0 9.66 9.66 0 1119.318 0zM30.121 45.84a1.932 1.932 0 11-3.863 0 1.932 1.932 0 113.863 0z",
  strokeWidth: 0.99939488,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.379 23.303L27.545 43.91M32.697 24.59l14.038 21.38M17.5 29.742L9.515 45.197h16.743M28.833 43.91l6.955-14.168"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M8.227 20.728H18.53v2.576H8.227z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.121 25.879c4.834-2.002 14.167-6.44 12.879-2.576"
}));

var SvgBicycle = function SvgBicycle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBicycle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bicycle.046ff61d.svg";
export { ForwardRef as ReactComponent };